import * as angular from "angular";
import {IController, IIntervalService} from "angular";
import * as _ from "lodash";

export class routeLoadingColumnCtrl implements IController {
  route: any;
  settings: any;

  public services: any;
  public paginationPages: any;
  public displayedServices: any;

  private limit: any;
  private offset: any;
  private intervalRef: any;
  private intervalInMilli: any;

  /* @ngInject */
  constructor(private $interval: IIntervalService) {
  }

  $onInit() {
    if (!this.settings) {
      this.settings = {}
    }
    this.services = [];
    this.limit = 10;
    this.offset = 0;

    this.setPagination(this.route);
    this.setInterval();
  };

  $onChanges(changes) {
    if (changes.route && !changes.route.isFirstChange()) {
      const currentRoute = changes.route.currentValue,
        previousRoute = changes.route.previousValue;

      if (!_.isEqual(_.get(currentRoute, 'serviceIdList'), _.get(previousRoute, 'serviceIdList'))) {
        this.$onInit();
      }
    }

    if (changes.settings && !changes.settings.isFirstChange()) {
      var currentSettings = changes.settings.currentValue,
        previousSettings = changes.settings.previousValue;

      if (currentSettings.orderType !== previousSettings.orderType) {
        this.offset = 0;

        this.setDisplayedServices();
      }
      this.setInterval();
      if (currentSettings.showNotPacked !== previousSettings.showNotPacked) {
        this.$onInit();
      }
    }
  }

  $onDestroy() {
    this.destroyInterval();
  }


  onBack() {
    this.offset -= this.limit;

    if (this.offset < 0) {
      this.offset = this.services.length - (this.services.length % this.limit);
    }

    this.setDisplayedServices();
    this.setInterval();
  }

  onNext() {
    this.offset += this.limit;

    if (this.offset >= this.services.length) {
      this.offset = 0;
    }

    this.setDisplayedServices();
    this.setInterval();
  }

  private setPagination(route) {
    this.services = [];
    this.displayedServices = [];
    if (this.settings.showNotPacked) {
      this.services = route.serviceList;
    } else {
      this.services = _.filter(route.serviceList, (s) => {
        return s.autoGeneratedPacked;
      })
    }

    this.paginationPages = Math.ceil(_.get(this.services, 'length', 0) / this.limit);
    this.setDisplayedServices();
  }

  private setDisplayedServices() {
    const services: any[] = _.slice(this.services, this.offset, (this.offset + this.limit));
    this.displayedServices = [];

    switch (this.settings.orderType) {
      case 'NAME': {
        this.displayedServices = _.sortBy(services, this.settings.idType);
        break;
      }
      case 'NOTPACKED': {
        const packed = _.filter(services, (s) => {
          return s.autoGeneratedPacked;
        });
        const unpacked = _.difference(services, packed);
        this.displayedServices = _.concat(unpacked, packed);

        break;
      }
      case 'ORDER': {
        this.displayedServices = services;
        break;
      }
    }


  }

  private setInterval() {
    this.destroyInterval();

    if (this.settings.routeColumnAutomation === 'AUTO') {
      this.intervalInMilli = this.settings.routeColumnAutomationTime ? (this.settings.routeColumnAutomationTime * 60000) : 5000;
      this.intervalRef = this.$interval(() => {
        this.onNext();
      }, this.intervalInMilli);
    }
  }

  private destroyInterval() {
    if (this.intervalRef) {
      this.$interval.cancel(this.intervalRef);
      this.intervalRef = undefined;
    }
  }

}

angular
  .module('bringoz.admin.lean-planning')
  .component('routeLoadingColumn', {
    bindings: {
      route: '<',
      settings: '<?' // in Minutes
    },
    template: require('./route-loading-column.html').default,
    controller: routeLoadingColumnCtrl
  });
